import { render, staticRenderFns } from "./BulkUpload.vue?vue&type=template&id=029b96f8"
import script from "./BulkUpload.vue?vue&type=script&lang=js"
export * from "./BulkUpload.vue?vue&type=script&lang=js"
import style0 from "./BulkUpload.vue?vue&type=style&index=0&id=029b96f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports